import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function json(pairs) {
  var res = {};
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var name = _destruct__k2r9zo.ze();
    var value = _destruct__k2r9zo.af();
    res[name] = value;
  }
  return res;
}
function add(_this__u8e3s4, other) {
  var keys = Object.keys(other);
  var inductionVariable = 0;
  var last = keys.length;
  while (inductionVariable < last) {
    var key = keys[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    if (other.hasOwnProperty(key)) {
      _this__u8e3s4[key] = other[key];
    }
  }
  return _this__u8e3s4;
}
//region block: exports
export {
  add as add1feko8hhyuck0,
  json as json3n35pf5np6si4,
};
//endregion

//# sourceMappingURL=json.mjs.map
